import { render, staticRenderFns } from "./sharedResource.vue?vue&type=template&id=630f788a&scoped=true"
import script from "./sharedResource.vue?vue&type=script&lang=js"
export * from "./sharedResource.vue?vue&type=script&lang=js"
import style0 from "./sharedResource.vue?vue&type=style&index=0&id=630f788a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630f788a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630f788a')) {
      api.createRecord('630f788a', component.options)
    } else {
      api.reload('630f788a', component.options)
    }
    module.hot.accept("./sharedResource.vue?vue&type=template&id=630f788a&scoped=true", function () {
      api.rerender('630f788a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/sharedResource.vue"
export default component.exports